import React, { useState } from "react";

type PlayerFormProps = {
  onSubmit: (playerNames: string[]) => void;
};

const PlayerForm: React.FC<PlayerFormProps> = ({ onSubmit }) => {
  const [players, setPlayers] = useState<string[]>(["", "", "", ""]);

  const handleInputChange = (index: number, value: string) => {
    const newPlayers = [...players];
    newPlayers[index] = value;
    setPlayers(newPlayers);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Filter out empty player names
    const validPlayers = players.filter((name) => name.trim() !== "");
    if (validPlayers.length === 0) {
      alert("Please enter at least one player name");
      return;
    }
    onSubmit(validPlayers);
  };

  return (
    <div className="player-form-container">
      <div className="player-form">
        <h2>Enter Player Names</h2>
        <form onSubmit={handleSubmit}>
          {players.map((player, index) => (
            <div key={index} className="player-input">
              <label htmlFor={`player-${index + 1}`}>Player {index + 1}:</label>
              <input
                id={`player-${index + 1}`}
                type="text"
                value={player}
                onChange={(e) => handleInputChange(index, e.target.value)}
                placeholder={`Player ${index + 1} name`}
                autoComplete="off"
              />
            </div>
          ))}
          <button type="submit" className="submit-btn">
            Start Game
          </button>
        </form>
      </div>
    </div>
  );
};

export default PlayerForm;
